import { useEffect, useState } from "react";
import firebase from "../firebase";

import DB_PATH from "../DB_PATH";
import { Author } from "../../types/Author";

type AuthorResponse = Author[];

export default ({ communityId }: { communityId: string }): AuthorResponse => {
  const [quotes, setQuotes] = useState<Author[]>([]);

  useEffect(() => {
    if (!communityId) return;
    const unsubscribe = firebase
      .firestore()
      .collection(DB_PATH.QUOTE)
      .where("communityId", "==", communityId)
      .onSnapshot(
        (snapshot) => {
          const quotesData = snapshot.docs.map((doc) => doc.data() as Author);
          setQuotes(quotesData);
        },
        (error) => {
          console.error("Error fetching quotes:", error);
        }
      );

    // Clean up the listener on unmount
    return () => unsubscribe();
  }, [communityId]);

  return quotes;
};
